import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter as Router } from "react-router-dom"
import "./index.css"
import App from "./App"
import { Provider } from "react-redux"
import store from "./store/store"
import ReactGA from "react-ga"
import "./main"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
ReactGA.initialize("G-CFNGC8E4Y4")

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
